<!-- Navbar & Carousel Start -->
<div class="container-fluid position-relative p-0">
  <!-- Navigation Bar -->
  <nav class="navbar navbar-expand-lg navbar-dark px-5 py-3 py-lg-0" [ngClass]="{'navbar-scrolled': !isTransparent}">
    <!-- Brand -->
    <a [routerLink]="['/']" class="navbar-brand p-0">
      <h1 class="m-0">Delex</h1>
    </a>

    <!-- Mobile Toggle Button -->
    <button class="navbar-toggler" type="button" (click)="toggleMenu()" [attr.aria-expanded]="isMenuOpen" aria-label="Toggle navigation">
      <span class="fa fa-bars"></span>
    </button>

    <!-- Navigation Menu -->
    <div class="collapse navbar-collapse" [ngClass]="{'show': isMenuOpen}" id="navbarCollapse">
      <div class="navbar-nav ms-auto py-0">
        <!-- Home Link -->
        <a [routerLink]="['/']" class="nav-item nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="closeMenu()">
          Home
        </a>

        <!-- About Link -->
        <a [routerLink]="['/about-us']" class="nav-item nav-link" routerLinkActive="active" (click)="closeMenu()">
          About
        </a>

        <!-- Services Link -->
        <a [routerLink]="['/services']" class="nav-item nav-link" routerLinkActive="active" (click)="closeMenu()">
          Services
        </a>

        <!-- Blog Dropdown -->
        <div class="nav-item dropdown" [ngClass]="{'show': activeDropdown === 'blog'}">
          <a href="javascript:void(0)" class="nav-link dropdown-toggle" (click)="toggleDropdown('blog', $event)" [attr.aria-expanded]="activeDropdown === 'blog'">
            Blog
          </a>
          <div class="dropdown-menu m-0 animate__animated" [ngClass]="{'show': activeDropdown === 'blog', 'animate__fadeIn': activeDropdown === 'blog'}">
            <a [routerLink]="['/blog-grid']" class="dropdown-item" (click)="closeMenu()">Blog Grid</a>
            <a [routerLink]="['/blog-standard']" class="dropdown-item" (click)="closeMenu()">Blog Standard</a>
          </div>
        </div>

        <!-- Pages Dropdown -->
        <div class="nav-item dropdown" [ngClass]="{'show': activeDropdown === 'pages'}">
          <a href="javascript:void(0)" class="nav-link dropdown-toggle" (click)="toggleDropdown('pages', $event)" [attr.aria-expanded]="activeDropdown === 'pages'">
            Pages
          </a>
          <div class="dropdown-menu m-0 animate__animated" [ngClass]="{'show': activeDropdown === 'pages', 'animate__fadeIn': activeDropdown === 'pages'}">
            <a [routerLink]="['/pricing-table']" class="dropdown-item" (click)="closeMenu()">Pricing Plan</a>
            <a [routerLink]="['/our-features']" class="dropdown-item" (click)="closeMenu()">Our Features</a>
            <a [routerLink]="['/our-team']" class="dropdown-item" (click)="closeMenu()">Team Members</a>
            <a [routerLink]="['/testimonials']" class="dropdown-item" (click)="closeMenu()">Testimonials</a>
            <a [routerLink]="['/quote']" class="dropdown-item" (click)="closeMenu()">Free Quote</a>
            <a [routerLink]="['/coming-soon']" class="dropdown-item" (click)="closeMenu()">Coming Soon</a>
            <a [routerLink]="['/error']" class="dropdown-item" (click)="closeMenu()">Error 404</a>
          </div>
        </div>

        <!-- Contact Link -->
        <a [routerLink]="['/contact']" class="nav-item nav-link" routerLinkActive="active" (click)="closeMenu()">
          Contact
        </a>
      </div>
    </div>
  </nav>
</div>
<!-- Navbar & Carousel End -->